import { BUTTON_SIZE, BUTTON_TYPE, DSBottomSheet, DSButton, DSModal } from '@repo/design-system/index'
import {
  QIcon_arrow_right,
  QIcon_calendar_filled,
  QIcon_clock,
  QIcon_question_outline,
  QIcon_refresh,
} from '@repo/icons/index'
import { useState } from 'react'
import { IWeeklyLessonProgress, IWeeklyLessonProgressWeeks } from '../../../model/credit.interface'
import useIsMobile from '../../../modules/hooks/common/useIsMobile'
import { n_common, n_credit, n_weekly } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { COLORS } from '../../../modules/vars'
import WeeklyLessonPackagesModal from '../../modal/WeeklyLessonPackagesModal'

const CalendarIcon = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6309_62974)">
        <rect x="8" y="9.05469" width="31.6324" height="31.6324" rx="2.75065" fill="white" />
        <rect x="8" y="9.05469" width="31.6324" height="6.18896" fill="#9B8AEE" />
        <rect x="8" y="15.2461" width="31.6324" height="1.71915" fill="#7B69DE" />
        <circle cx="13.6913" cy="21.8395" r="2.55826" fill="#E0E3F0" />
        <circle cx="23.9235" cy="21.8395" r="2.55826" fill="#E0E3F0" />
        <circle cx="23.9235" cy="28.5583" r="2.55826" fill="#E0E3F0" />
        <circle cx="34.3737" cy="21.8395" r="2.55826" fill="#E0E3F0" />
        <circle cx="13.6911" cy="28.8786" r="2.55826" fill="#E0E3F0" />
        <circle cx="13.6911" cy="35.9137" r="2.55826" fill="#E0E3F0" />
        <circle cx="34.1559" cy="28.8786" r="2.55826" fill="#E0E3F0" />
        <circle cx="23.9235" cy="35.9137" r="2.55826" fill="#E0E3F0" />
        <circle cx="34.3737" cy="35.9137" r="2.55826" fill="#E0E3F0" />
        <circle cx="13.8827" cy="12.1142" r="2.2001" fill="#EFF1F9" />
        <circle cx="33.4422" cy="12.1473" r="2.19811" fill="#EFF1F9" />
      </g>
      <path
        d="M12.2969 8.00053C12.2969 7.12435 13.0072 6.41406 13.8833 6.41406C14.7595 6.41406 15.4698 7.12435 15.4698 8.00053V12.1879C15.4698 13.0641 14.7595 13.7744 13.8833 13.7744C13.0072 13.7744 12.2969 13.0641 12.2969 12.1879V8.00053Z"
        fill="#C9CCDE"
      />
      <path
        d="M31.8564 8.00053C31.8564 7.12435 32.5667 6.41406 33.4429 6.41406C34.3191 6.41406 35.0294 7.12435 35.0294 8.00053V12.1879C35.0294 13.0641 34.3191 13.7744 33.4429 13.7744C32.5667 13.7744 31.8564 13.0641 31.8564 12.1879V8.00053Z"
        fill="#C9CCDE"
      />
      <defs>
        <clipPath id="clip0_6309_62974">
          <rect x="8" y="9.05469" width="31.6324" height="31.6324" rx="2.75065" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const FailCalendarIcon = () => {
  return (
    <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10376_14221)">
        <rect x="8" y="9.05469" width="31.6324" height="31.6324" rx="2.75065" fill="white" />
        <rect x="8" y="9.05469" width="31.6324" height="6.18896" fill="#FC997D" />
        <rect x="8" y="15.2461" width="31.6324" height="1.71915" fill="#F9725C" />
        <circle cx="13.6913" cy="21.8395" r="2.55826" fill="#E0E3F0" />
        <circle cx="23.9235" cy="21.8395" r="2.55826" fill="#E0E3F0" />
        <circle cx="23.9235" cy="28.5583" r="2.55826" fill="#E0E3F0" />
        <circle cx="34.3737" cy="21.8395" r="2.55826" fill="#E0E3F0" />
        <circle cx="13.6911" cy="28.8786" r="2.55826" fill="#E0E3F0" />
        <circle cx="13.6911" cy="35.9137" r="2.55826" fill="#E0E3F0" />
        <circle cx="34.1559" cy="28.8786" r="2.55826" fill="#E0E3F0" />
        <circle cx="23.9235" cy="35.9137" r="2.55826" fill="#E0E3F0" />
        <circle cx="34.3737" cy="35.9137" r="2.55826" fill="#E0E3F0" />
        <circle cx="13.8827" cy="12.1142" r="2.2001" fill="#EFF1F9" />
        <circle cx="33.4422" cy="12.1473" r="2.19811" fill="#EFF1F9" />
      </g>
      <path
        d="M12.2969 8.00053C12.2969 7.12435 13.0072 6.41406 13.8833 6.41406C14.7595 6.41406 15.4698 7.12435 15.4698 8.00053V12.1879C15.4698 13.0641 14.7595 13.7744 13.8833 13.7744C13.0072 13.7744 12.2969 13.0641 12.2969 12.1879V8.00053Z"
        fill="#C9CCDE"
      />
      <path
        d="M31.8564 8.00053C31.8564 7.12435 32.5667 6.41406 33.4429 6.41406C34.3191 6.41406 35.0294 7.12435 35.0294 8.00053V12.1879C35.0294 13.0641 34.3191 13.7744 33.4429 13.7744C32.5667 13.7744 31.8564 13.0641 31.8564 12.1879V8.00053Z"
        fill="#C9CCDE"
      />
      <path
        d="M27.25 35C27.25 29.6144 31.6156 25.25 37 25.25C42.3856 25.25 46.75 29.6144 46.75 35C46.75 40.3844 42.3856 44.75 37 44.75C31.6155 44.75 27.25 40.3845 27.25 35Z"
        fill="#F9725C"
      />
      <path
        d="M36.3881 40.0344C36.2083 39.9221 36.0644 39.7707 35.9574 39.5834C35.8484 39.3927 35.7961 39.1843 35.8 38.9623C35.796 38.7436 35.8488 38.5385 35.9585 38.3515C36.0663 38.1678 36.2111 38.0204 36.3915 37.9127L36.3934 37.9115C36.5793 37.8033 36.7828 37.7493 36.9999 37.7493C37.2105 37.7493 37.4082 37.804 37.5895 37.9121C37.7747 38.0201 37.922 38.1701 38.03 38.3586C38.1381 38.5432 38.195 38.744 38.1998 38.9579L38.1999 38.9665C38.1953 39.1873 38.1388 39.3941 38.0306 39.5834C37.9228 39.7719 37.776 39.9236 37.5919 40.0356L37.5905 40.0365C37.4089 40.1449 37.2108 40.1998 36.9999 40.1998C36.7828 40.1998 36.5794 40.1458 36.3935 40.0376L36.3881 40.0344Z"
        fill="white"
      />
      <path
        d="M37.269 36.431H36.7254C36.3458 36.431 36.0354 36.1285 36.0256 35.7491L35.8907 30.5179C35.8806 30.1243 36.1968 29.7998 36.5905 29.7998H37.4089C37.8028 29.7998 38.1192 30.1247 38.1086 30.5185L37.9687 35.7498C37.9586 36.1289 37.6483 36.431 37.269 36.431Z"
        fill="white"
      />
      <defs>
        <clipPath id="clip0_10376_14221">
          <rect x="8" y="9.05469" width="31.6324" height="31.6324" rx="2.75065" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const SuccessCalendarIcon = () => {
  return (
    <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6309_51318)">
        <rect x="8" y="9.05469" width="31.6324" height="31.6324" rx="2.75065" fill="white" />
        <rect x="8" y="9.05469" width="31.6324" height="6.18896" fill="#9B8AEE" />
        <rect x="8" y="15.2461" width="31.6324" height="1.71915" fill="#7B69DE" />
        <circle cx="13.6912" cy="21.8395" r="2.55826" fill="#E0E3F0" />
        <circle cx="23.9235" cy="21.8395" r="2.55826" fill="#E0E3F0" />
        <circle cx="23.9235" cy="28.5583" r="2.55826" fill="#E0E3F0" />
        <circle cx="34.3737" cy="21.8395" r="2.55826" fill="#E0E3F0" />
        <circle cx="13.6911" cy="28.8786" r="2.55826" fill="#E0E3F0" />
        <circle cx="13.6911" cy="35.9137" r="2.55826" fill="#E0E3F0" />
        <circle cx="34.1559" cy="28.8786" r="2.55826" fill="#E0E3F0" />
        <circle cx="23.9235" cy="35.9137" r="2.55826" fill="#E0E3F0" />
        <circle cx="34.3737" cy="35.9137" r="2.55826" fill="#E0E3F0" />
        <circle cx="13.8827" cy="12.1142" r="2.2001" fill="#EFF1F9" />
        <circle cx="33.4422" cy="12.1473" r="2.19811" fill="#EFF1F9" />
      </g>
      <path
        d="M12.2969 8.00053C12.2969 7.12435 13.0072 6.41406 13.8833 6.41406C14.7595 6.41406 15.4698 7.12435 15.4698 8.00053V12.1879C15.4698 13.0641 14.7595 13.7744 13.8833 13.7744C13.0072 13.7744 12.2969 13.0641 12.2969 12.1879V8.00053Z"
        fill="#C9CCDE"
      />
      <path
        d="M31.8564 8.00053C31.8564 7.12435 32.5667 6.41406 33.4429 6.41406C34.3191 6.41406 35.0294 7.12435 35.0294 8.00053V12.1879C35.0294 13.0641 34.3191 13.7744 33.4429 13.7744C32.5667 13.7744 31.8564 13.0641 31.8564 12.1879V8.00053Z"
        fill="#C9CCDE"
      />
      <path
        d="M47 35C47 40.5228 42.5228 45 37 45C31.4772 45 27 40.5228 27 35C27 29.4772 31.4772 25 37 25C42.5228 25 47 29.4772 47 35Z"
        fill="#7B69DE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.6111 30.2085C43.0483 30.546 43.1291 31.174 42.7916 31.6112L36.6151 39.6112C36.4318 39.8486 36.1516 39.9912 35.8517 39.9997C35.5519 40.0081 35.2641 39.8815 35.0677 39.6548L31.2442 35.241C30.8826 34.8236 30.9278 34.192 31.3453 33.8304C31.7627 33.4688 32.3942 33.5141 32.7559 33.9315L35.779 37.4214L41.2085 30.3889C41.546 29.9518 42.174 29.871 42.6111 30.2085Z"
        fill="white"
      />
      <defs>
        <clipPath id="clip0_6309_51318">
          <rect x="8" y="9.05469" width="31.6324" height="31.6324" rx="2.75065" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const WeeklyLessonCurrentProgress = ({ week }: { week: IWeeklyLessonProgressWeeks }) => {
  const { t } = useTranslation()
  if (week.achieved) {
    if (week.achievement_detail == 'tutor_cancelled' || week.achievement_detail == 'tutor_noshow') {
      return (
        <div className="flex items-center flex-row gap-x-[12px] rounded-[8px] bg-gray-50 p-[8px]">
          <SuccessCalendarIcon />
          <div>
            <div className="Body1-16Bd text-gray-700">{t(n_credit.weekly.banner_title4)}</div>
            <div className="Body2-14Md text-gray-700">{t(n_credit.weekly.banner_desc4)}</div>
          </div>
        </div>
      )
    } else {
      return (
        <div className="flex items-center flex-row gap-x-[12px] rounded-[8px] bg-gray-50 p-[8px]">
          <SuccessCalendarIcon />
          <div>
            <div className="Body1-16Bd text-gray-700">{t(n_weekly.done.title)}</div>
            <div className="Body2-14Md text-gray-700">{t(n_credit.weekly.banner_desc3)}</div>
          </div>
        </div>
      )
    }
  }

  return (
    <div>
      {week.upcoming_lesson_info ? (
        <div className="flex items-center flex-row gap-x-[12px] rounded-[8px] bg-gray-50 p-[8px]">
          <CalendarIcon />
          <div>
            <div className="Body1-16Bd text-gray-700">{t(n_credit.weekly.banner_title2)}</div>
            <div className="Body2-14Md text-gray-600">{week.upcoming_lesson_info?.formatted_period}</div>
          </div>
        </div>
      ) : (
        <div>
          {week.achievement_detail == 'student_cancelled' || week.achievement_detail == 'student_noshow' ? (
            <div className="flex items-center flex-row gap-x-[12px] rounded-[8px] bg-red-50 p-[8px]">
              <FailCalendarIcon />
              <div>
                <div className="Body1-16Bd text-gray-700">{t(n_credit.weekly.banner_title5)}</div>
                <div className="Body2-14Md text-gray-700">{t(n_credit.weekly.banner_desc5)}</div>
              </div>
            </div>
          ) : (
            <div className="flex items-center flex-row gap-x-[12px] rounded-[8px] bg-red-50 p-[8px]">
              <FailCalendarIcon />
              <div>
                <div className="Body1-16Bd text-gray-700 flex items-center gap-x-[4px]">
                  {t(n_credit.weekly.banner_title1)}
                  <span>
                    <QIcon_arrow_right width={20} height={20} />
                  </span>
                </div>
                <div className="Body2-14Md text-gray-700">
                  {t(n_credit.weekly.banner_desc(week.formatted_end_time))}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

const WeeklyLessonProgressStatus = ({
  data,
  handleWeeklyModal,
  couponBundle,
  setCouponBundle,
  weeklyLessonPackages,
}: {
  data: IWeeklyLessonProgress
  handleWeeklyModal: (e: any) => Promise<void>
  couponBundle
  setCouponBundle
  weeklyLessonPackages
}) => {
  const { t, isLocaleKO } = useTranslation()
  const [showWeeklyLessonInfo, setShowWeeklyLessonInfo] = useState(false)
  const [showWeeklyLessonPackages, setShowWeeklyLessonPackages] = useState(false)

  const isMobile = useIsMobile()
  const currentWeek = data.weeks.find((week) => week.stage == 'current')

  const handleShowWeeklyLessonInfo = () => {
    setShowWeeklyLessonInfo(true)
  }

  const onClickWeeklyLessonPackages = () => {
    setShowWeeklyLessonPackages(true)
  }

  return (
    <div className="mt-[4px] rounded-[8px] border-[1px] border-gray-200 p-[16px]">
      <div className="flex flex-row items-start gap-x-[4px]">
        <div className="Caption-12Bd flex rounded-[4px] bg-gray-100 py-[2px] px-[6px] text-gray-600">
          {couponBundle.lesson_duration == 40 ? t(n_common.label_40min) : t(n_common.label_20min)}
        </div>
        {couponBundle.is_weekly_lesson_package && (
          <div className="Caption-12Bd rounded-[4px] bg-red-50 px-[6px] pt-[2px] text-red-500">
            {t(n_common.label_weekly)}
          </div>
        )}
      </div>
      <div className="flex items-center justify-between">
        <div className="Title2-18Bd mt-[8px]">{isLocaleKO ? couponBundle.name : couponBundle.name_eng}</div>
        {weeklyLessonPackages && weeklyLessonPackages.length > 0 && (
          <div>
            <DSButton onClick={onClickWeeklyLessonPackages} size={BUTTON_SIZE.XS} type={BUTTON_TYPE.OUTLINE}>
              <DSButton.Label>{t(n_credit.weekly.credit_btn)}</DSButton.Label>
            </DSButton>
          </div>
        )}
      </div>
      <div className="h-[1px] bg-gray-200 my-[16px]"></div>
      <div className="mt-[8px] flex items-center">
        <div className="Title2-18Bd flex items-center gap-x-[4px]">
          {t(n_credit.weekly.week(currentWeek.week_number))}
        </div>
      </div>
      <div className="Body2-14Md text-gray-600 mt-[4px] whitespace-nowrap">{currentWeek.period}</div>
      <div className="mt-[16px]">
        <WeeklyLessonCurrentProgress week={currentWeek} />
      </div>
      <div className="mt-[16px]">
        <DSButton
          onClick={handleWeeklyModal}
          type={BUTTON_TYPE.OUTLINE}
          size={BUTTON_SIZE.MD}
          customBorderColor={COLORS.PURPLE600}
        >
          <DSButton.Label customTxtColor={COLORS.PURPLE600}>{t(n_credit.weekly.btn)}</DSButton.Label>
        </DSButton>
      </div>
      <div
        className="mt-[12px] Body2-14Bd text-gray-500 flex items-center justify-end gap-x-[2px] cursor-pointer"
        onClick={handleShowWeeklyLessonInfo}
      >
        {t(n_credit.weekly.txt)}
        <QIcon_question_outline color={COLORS.GRAY500} />
      </div>

      {isMobile ? (
        <DSBottomSheet
          id="DsBottomSheet"
          isOpen={showWeeklyLessonInfo}
          setIsOpen={setShowWeeklyLessonInfo}
          closeButton={true}
          maxH={650}
        >
          <div className="p-[20px]">
            <div className="Title2-18Bd">{t(n_credit.weekly.popup2.title)}</div>
            <div className="mt-[20px]">
              <div className="grid grid-cols-1 gap-y-[16px]">
                <div>
                  <div className="flex items-center gap-x-[4px]">
                    <div>
                      <QIcon_calendar_filled color={COLORS.PURPLE400} width={20} height={20} />
                    </div>
                    <div className="Body1-16Bd text-gray-700">{t(n_credit.weekly.popup2.subhead1)}</div>
                  </div>
                  <div className="p-[8px] bg-gray-50 Body2-14Md">{t(n_credit.weekly.popup2.desc1)}</div>
                </div>
                <div>
                  <div className="flex items-center gap-x-[4px]">
                    <div>
                      <QIcon_refresh color={COLORS.PURPLE400} width={20} height={20} />
                    </div>
                    <div className="Body1-16Bd text-gray-700">{t(n_credit.weekly.popup2.subhead2)}</div>
                  </div>
                  <div className="p-[8px] bg-gray-50 Body2-14Md">{t(n_credit.weekly.popup2.desc2)}</div>
                </div>
                <div>
                  <div className="flex items-center gap-x-[4px]">
                    <div>
                      <QIcon_clock color={COLORS.PURPLE400} width={20} height={20} />
                    </div>
                    <div className="Body1-16Bd text-gray-700">{t(n_credit.weekly.popup2.subhead3)}</div>
                  </div>
                  <div className="p-[8px] bg-gray-50 Body2-14Md">{t(n_credit.weekly.popup2.desc3)}</div>
                </div>
              </div>
            </div>
          </div>
        </DSBottomSheet>
      ) : (
        <DSModal
          id="showWeeklyLessonInfo"
          isOpen={showWeeklyLessonInfo}
          setIsOpen={setShowWeeklyLessonInfo}
          size="xl"
          closeButton={true}
          closeOnDim={true}
        >
          <>
            <DSModal.Title>{t(n_credit.weekly.popup2.title)}</DSModal.Title>
            <DSModal.Content>
              <div className="grid grid-cols-1 gap-y-[16px]">
                <div>
                  <div className="flex items-center gap-x-[4px]">
                    <div>
                      <QIcon_calendar_filled color={COLORS.PURPLE400} width={20} height={20} />
                    </div>
                    <div className="Body1-16Bd text-gray-700">{t(n_credit.weekly.popup2.subhead1)}</div>
                  </div>
                  <div className="p-[8px] bg-gray-50 Body2-14Md">{t(n_credit.weekly.popup2.desc1)}</div>
                </div>
                <div>
                  <div className="flex items-center gap-x-[4px]">
                    <div>
                      <QIcon_refresh color={COLORS.PURPLE400} width={20} height={20} />
                    </div>
                    <div className="Body1-16Bd text-gray-700">{t(n_credit.weekly.popup2.subhead2)}</div>
                  </div>
                  <div className="p-[8px] bg-gray-50 Body2-14Md">{t(n_credit.weekly.popup2.desc2)}</div>
                </div>
                <div>
                  <div className="flex items-center gap-x-[4px]">
                    <div>
                      <QIcon_clock color={COLORS.PURPLE400} width={20} height={20} />
                    </div>
                    <div className="Body1-16Bd text-gray-700">{t(n_credit.weekly.popup2.subhead3)}</div>
                  </div>
                  <div className="p-[8px] bg-gray-50 Body2-14Md">{t(n_credit.weekly.popup2.desc3)}</div>
                </div>
              </div>
            </DSModal.Content>
          </>
        </DSModal>
      )}
      <WeeklyLessonPackagesModal
        showWeeklyLessonPackages={showWeeklyLessonPackages}
        setShowWeeklyLessonPackages={setShowWeeklyLessonPackages}
        weeklyLessonPackages={weeklyLessonPackages}
        couponBundle={couponBundle}
        setCouponBundle={setCouponBundle}
      />
    </div>
  )
}
export default WeeklyLessonProgressStatus
